import React from 'react';
import './SessionCard.css';

const THUMB_PATTERNS = [
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <circle cx="34" cy="34" r="18" stroke="#F5F0E8" strokeWidth="0.5" opacity=".5" />
      <circle cx="34" cy="34" r="10" stroke="#F5F0E8" strokeWidth="0.5" opacity=".35" />
      <line x1="16" y1="34" x2="52" y2="34" stroke="#F5F0E8" strokeWidth="0.5" opacity=".25" />
      <line x1="34" y1="16" x2="34" y2="52" stroke="#F5F0E8" strokeWidth="0.5" opacity=".25" />
    </svg>
  ),
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <rect x="18" y="18" width="32" height="32" stroke="#F5F0E8" strokeWidth="0.5" opacity=".5" />
      <rect x="24" y="24" width="20" height="20" stroke="#F5F0E8" strokeWidth="0.5" opacity=".35" />
      <rect x="30" y="30" width="8" height="8" fill="#F5F0E8" opacity=".3" />
    </svg>
  ),
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <path d="M34 12 L54 48 L14 48 Z" stroke="#F5F0E8" strokeWidth="0.5" fill="none" opacity=".5" />
      <path d="M34 22 L46 44 L22 44 Z" stroke="#F5F0E8" strokeWidth="0.5" fill="none" opacity=".3" />
    </svg>
  ),
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <line x1="18" y1="18" x2="50" y2="50" stroke="#F5F0E8" strokeWidth="0.5" opacity=".45" />
      <line x1="50" y1="18" x2="18" y2="50" stroke="#F5F0E8" strokeWidth="0.5" opacity=".45" />
      <circle cx="34" cy="34" r="9" stroke="#F5F0E8" strokeWidth="0.5" opacity=".4" />
      <circle cx="34" cy="34" r="2" fill="#F5F0E8" opacity=".4" />
    </svg>
  ),
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <path d="M34 14 Q52 34 34 54 Q16 34 34 14" stroke="#F5F0E8" strokeWidth="0.5" fill="none" opacity=".5" />
      <circle cx="34" cy="34" r="6" stroke="#F5F0E8" strokeWidth="0.5" opacity=".4" />
    </svg>
  ),
  (color) => (
    <svg width="100%" height="100%" viewBox="0 0 68 68" fill="none">
      <rect width="68" height="68" fill={color} />
      <line x1="12" y1="34" x2="56" y2="34" stroke="#F5F0E8" strokeWidth="0.5" opacity=".35" />
      <line x1="34" y1="12" x2="34" y2="56" stroke="#F5F0E8" strokeWidth="0.5" opacity=".35" />
      <line x1="18" y1="18" x2="50" y2="50" stroke="#F5F0E8" strokeWidth="0.5" opacity=".25" />
      <line x1="50" y1="18" x2="18" y2="50" stroke="#F5F0E8" strokeWidth="0.5" opacity=".25" />
      <circle cx="34" cy="34" r="5" stroke="#F5F0E8" strokeWidth="0.5" opacity=".45" />
    </svg>
  ),
];

const THUMB_COLORS = ['#5C6B5A','#7A6B55','#5A6B7A','#6B5A7A','#5A7A6B','#7A5A5A'];

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('es-AR', { day: 'numeric', month: 'long', year: 'numeric' });
}

export default function SessionCard({ session, progress, listened, favorite, onClick }) {
  const idx       = (session.id - 1) % THUMB_PATTERNS.length;
  const color     = THUMB_COLORS[idx];
  const Pattern   = THUMB_PATTERNS[idx];
  const thumbSrc  = session.imageUrl;

  return (
    <div className="sc-item" onClick={onClick}>
      <div className="sc-thumb">
        {thumbSrc
          ? <img src={thumbSrc} alt={session.title} className="sc-thumb-img" />
          : <Pattern color={color} />
        }
        {listened && (
          <div className="sc-listened-badge" title="Escuchada">✓</div>
        )}
      </div>

      <div className="sc-info">
        <div className="sc-code">{session.code}</div>
        <div className="sc-title">{session.title}</div>
        <div className="sc-meta">
          <span>{formatDate(session.classDate)}</span>
          <span className="sc-dot" />
          <span>{session.durationMinutes} min</span>
        </div>

        {progress > 0 && progress < 80 && (
          <div className="sc-progress-wrap">
            <div className="sc-progress-bar">
              <div className="sc-progress-fill" style={{ width: `${progress}%` }} />
            </div>
            <span className="sc-progress-pct">{Math.round(progress)}%</span>
          </div>
        )}
      </div>

      <div className="sc-right">
        {favorite && <span className="sc-fav-icon">♥</span>}
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className="sc-chevron">
          <path d="M5 3L9 7L5 11" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
}
